const checkInitialActiveTabId = ({
  initList = [],
  selectedIDS = []
}) => {
  if (!initList.length) return null;
  const targetIndex = initList.findIndex(
    (item) => item.options.find((opt) => selectedIDS.some((v) => v === opt.id))
  );
  if (targetIndex >= 0) {
    return initList[targetIndex].id;
  }
  return initList[0].id;
};

export { checkInitialActiveTabId };
//# sourceMappingURL=tabs.js.map
